import { MediaContentShowcaseItem } from "@onnit-js/ui/components/module/MediaContentShowcase";

const ingredientsFlowBlend: MediaContentShowcaseItem[] = [
    {
        image: `l-theanine.png?q=75&auto=compress,format`,
        imageWidth: 560,
        imageHeight: 560,
        title: "7 STRAINS OF PROBIOTICS",
        summary:
            // eslint-disable-next-line no-multi-str
            'Healthy bacteria that live in the gut. We included seven of the most important probiotic strains: \
            B. <span style="font-style:italic">subtitlus</span>, \
            B. <span style="font-style:italic">coagulans</span>, \
            L. <span style="font-style:italic">rhamnosus</span>, \
            L. <span style="font-style:italic">plantarum</span>, \
            L. <span style="font-style:italic">acidophilus</span>, \
            B. <span style="font-style:italic">infantis</span>, \
            B. <span style="font-style:italic">lactis</span>.',
        detail:
            'These microorganisms help contribute to a diverse gut microbiome.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `2023-AB-Wpage-keyIngredients-phosphatidyserine.png?q=75&auto=compress,format`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Betaine Hydrochloride (HCI)",
        summary: "A compound that helps promote stomach acid production.",
        detail:
            'Betaine HCl helps break down food and support digestion.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `2023-AB-Wpage-keyIngredients-alphagpc.png?q=75&auto=format`,
        imageWidth: 560,
        imageHeight: 560,
        title: '<span style="font-style:italic">Saccharomyces Boulardii</span>',
        summary: "A gut-friendly yeast that acts as a probiotic.",
        detail: 'S. <span style="font-style:italic">Boulardii</span> survives stomach acid to help restock your gut with beneficial microorganisms that support normal elimination.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `2023-AB-Wpage-keyIngredients-huperzia-extract.png?q=75&auto=format`,
        imageWidth: 560,
        imageHeight: 560,
        title: "2 Types of Organic Prebiotics",
        summary: 'Organic Jerusalem artichoke and organic dandelion root help feed the gut’s probiotic strains.<span class="oui-sup">&dagger;</span>',
        detail: 'By serving as food for probiotics, these prebiotics aid a positive balance in gut flora.<span class="oui-sup">&dagger;</span>',
    },
];

export default ingredientsFlowBlend;
